import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useAccountState } from 'contexts/account/account-context';

import ContactDetails from './features/contact-details/contact-details';
import GeneralSettings from './features/general-settings/general-settings';
import InventorySiloManagement from './features/inventory-silo-management/inventory-silo-management';

import Breadcrumbs from 'components/breadcrumbs';
import Error from 'components/error';
import LoadingSpinner from 'components/loading-spinner';

import SiteSettingsTabsHeader from './components/site-settings-tabs-header';
import ViewSiteTabsHeader from './components/view-site-tabs-header';
import { SiteSettingsProvider, useSiteSettingsState } from './context/site-settings-context';

type ParamTypes = {
  globalSiteId: string;
  siteTab: string;
};

enum Tabs {
  GENERAL = 'general',
  CONTACTS = 'contact-details',
  INVENTORY_SILO = 'inventory-silo-management',
}

type Props = {};

const ViewSite: React.FC<Props> = () => {
  const params = useParams<ParamTypes>();
  const { account } = useAccountState();
  const {
    siteSettingsQuery: { error, isError, isLoading },
  } = useSiteSettingsState();

  const currentSite = useMemo(
    () => account.company?.addressAccess.find((site) => site.id === params.globalSiteId),
    [account.company?.addressAccess, params.globalSiteId]
  );

  if (isLoading) return <LoadingSpinner />;

  if (isError) return <Error error={error} />;

  return (
    <>
      <SiteSettingsTabsHeader
        utils={
          <Breadcrumbs
            hideArrow
            crumbs={[
              {
                text: String(currentSite?.name),
                url: '',
              },
            ]}
          />
        }
      />
      <ViewSiteTabsHeader userType={account.currentUser?.userType} />
      {params.siteTab === Tabs.GENERAL && <GeneralSettings />}
      {params.siteTab === Tabs.INVENTORY_SILO && <InventorySiloManagement />}
      {params.siteTab === Tabs.CONTACTS && <ContactDetails />}
    </>
  );
};

const SiteSettingsContainer: React.FC<{}> = () => {
  return (
    <SiteSettingsProvider>
      <ViewSite />
    </SiteSettingsProvider>
  );
};

export default SiteSettingsContainer;
